import { Observable } from 'rxjs';

export interface AppStore<T, K> {
  value: T;
  select<TResult>(name: K): Observable<TResult>;
  set<TState>(name: K, state: TState): void;
}
